import React from "react";

import { Score } from "./Score";

import { CustomerScoreProps, allScores } from "../interface";

import { Title, Container, Content } from "./styles";

export const CustomerScore: React.FC<CustomerScoreProps> = (props) => {

  const { setCustomerResponseScore } = props;

  const handleCustomerScore = (score: string) => {
    setCustomerResponseScore(score);
  };

  return (
    <Container>
      <Title>
        O que você achou do nosso atendimento?
      </Title>

      <Content>
        {allScores.map((item) => (
          <Score
            key={item.score}
            img={item.img}
            handleCustomerScore={handleCustomerScore}
            text={item.score}
          />
        ))}
      </Content>
    </Container>
  );
};
